const main = 'seller-potential'
const relativeRoutes = {
  relativePage: `${main}/*`,
  relativeList: `${main}`,
}

const routes = {
  List: `/${main}`,
}

const SellerPotentialRoutes = { ...relativeRoutes, ...routes }

export default SellerPotentialRoutes
